/**
 * 项目基础信息实体
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '项目';

const Option = Select.Option;
const { TextArea } = Input;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [phase, setPhase] = useState('');
    const [area, setArea] = useState('');
    const [maintenanceContent, setMaintenanceContent] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setNumber('');
        setName('');
        setType('');
        setPhase('');
        setArea('');
        setMaintenanceContent('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setNumber(props.record.number);
            setName(props.record.name);
            setType(props.record.type);
            setPhase(props.record.phase);
            setArea(props.record.area);
            setMaintenanceContent(props.record.maintenance_content);
            setDescription(props.record.description);
        }
    }, [props.record]);

    const ok = () => {
        //  参数校验
        if (number === '') {
            messageApi.error('项目编号不能为空！');
            return;
        }
        if (name === '') {
            messageApi.error('项目名称不能为空！');
            return;
        }
        if (area === '') {
            messageApi.error('项目区域不能为空！');
            return;
        }
        if (type === '') {
            messageApi.error('项目类型不能为空！');
            return;
        }
        if (phase === '') {
            messageApi.error('项目阶段不能为空！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: CNF.api + 'project/bases' + (props.record ? '/' + props.record.key : ''),
            headers: AddRequestHeaders(),
            type: props.record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'number': number,
                'name': name,
                'type': type,
                'phase': phase,
                'area': area,
                'maintenance_content': maintenanceContent,
                'description': description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(props.record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}项目编号</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={number}
                            onChange={(e) => setNumber(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>{rff}项目名称</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={24}>{rff}项目区域</Col>
                    <Col span={24}>
                        <Input
                            placeholder='请输入'
                            value={area}
                            onChange={(e) => setArea(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={11}>{rff}项目类型</Col>
                    <Col span={12} offset={1}>{rff}项目阶段</Col>
                    <Col span={11}>
                        <Select
                            style={{ width: '100%' }}
                            value={type}
                            onChange={(value) => setType(value)}
                            disabled={loading}
                        >
                            <Option value=''>请选择项目类型</Option>
                            {
                                CNF.projectTypes.map((item, index) => {
                                    return <Option key={index} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={12} offset={1}>
                        <Select
                            value={phase}
                            style={{ width: '100%' }}
                            onChange={(value) => setPhase(value)}
                            disabled={loading}
                        >
                            <Option value=''>项目阶段</Option>
                            {
                                CNF.projectPhases && CNF.projectPhases.map((item, index) => {
                                    return <Option key={index} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                </Row>
                {
                    // 项目运维角色可见
                    props.btnLists.indexOf('btn_plms_om') >= 0 ? (
                        <Row style={{ marginTop: CNF.rowMarginTop }}>
                            <Col span={24}>维护内容</Col>
                            <Col span={24}>
                                <TextArea
                                    placeholder='维护内容可写在这里...'
                                    rows={2}
                                    autoSize={{ minRows: 4, maxRows: 6 }}
                                    value={maintenanceContent}
                                    onChange={(e) => setMaintenanceContent(e.target.value)}
                                    disabled={loading}

                                />
                            </Col>
                        </Row>
                    ) : ''
                }
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注说明</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='项目备注可写在这里...'
                            rows={2}
                            autoSize={{ minRows: 3, maxRows: 3 }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity